module.exports = __webpack_public_path__ + "img/3s.76df3744.png";